import { FC } from "react";

import { TeaserRecord } from "@graphql/types/graphql";
import { Teaser } from "./templates/Teaser";

export const CBTeaser: FC<TeaserRecord & { hasBorder?: boolean }> = ({
  icon,
  pretitle,
  title,
  description,
  button,
  hasBorder,
}) => {
  return (
    <Teaser
      icon={icon}
      pretitle={pretitle ?? undefined}
      title={title}
      description={description as any}
      button={button}
      hasBorder={hasBorder}
    />
  );
};
